"use client";

import { useState } from "react";
import { Download, Clock } from "lucide-react";
import { useT } from "@/lib/locale";

export function BillPdfButton({ personaId }: { personaId: string }) {
  const t = useT();
  const [state, setState] = useState<"idle" | "processing" | "done">("idle");
  const filename = `bill-${personaId.toLowerCase()}-may-2026.pdf`;

  function handleDownload() {
    setState("processing");
    setTimeout(() => {
      const a = document.createElement("a");
      a.href = `/demo/${filename}`;
      a.download = filename;
      a.click();
      setState("done");
      setTimeout(() => setState("idle"), 2000);
    }, 1500);
  }

  return (
    <button
      onClick={handleDownload}
      disabled={state === "processing"}
      className="btn-secondary flex-1 justify-center"
    >
      {state === "processing" ? (
        <>
          <Clock size={16} className="animate-spin" aria-hidden />
          {t("bill.preparingPdf")}
        </>
      ) : state === "done" ? (
        <>
          <Download size={16} aria-hidden />
          {filename} ✓
        </>
      ) : (
        <>
          <Download size={16} aria-hidden />
          {t("bill.downloadPdf")}
        </>
      )}
    </button>
  );
}
